const UseRefreshSessionAccess = ()=>{
    if ('undefined' == typeof window) return;
    const oktaToken = localStorage.getItem('okta-token-storage');
    const tokenJson = JSON.parse(oktaToken);
    const customerId = tokenJson?.idToken?.claims['com.priceline.profile.custId'];
    const custName = tokenJson?.idToken?.claims.name?.replace(/\s/g, '');
    const sessionStatus = localStorage.getItem('sessionStatus');
    if (customerId && custName) {
        localStorage.setItem('psid', `${custName}-${customerId}`);
        localStorage.setItem('sessionStatus', 'true');
    } else if ('true' === sessionStatus) {
        localStorage.removeItem('psid');
        sessionStorage.removeItem('pennysid');
        localStorage.setItem('sessionStatus', 'false');
    }
    return {};
};
const hooks_UseRefreshSessionAccess = UseRefreshSessionAccess;
export { hooks_UseRefreshSessionAccess as default };
